import React, { useRef, useState } from "react";
import downarrow from "../../Assets/Images/down-arrow.png";
import webappslider1 from "../../Assets/Images/web-app-slider-1.png";
import webappslider4 from "../../Assets/Images/web-app-slider-4.png";
import CRMimage from "../../Assets/Images/CRM-image.png";
import compressedview from "../../Assets/Images/compressed-view.png";
import calendaricon from "../../Assets/Images/calendar-icon.svg";
import popupbg from "../../Assets/Images/popup-bg.png";
import recordkeeper2 from "../../Assets/Images/record-keeper2.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Alert } from "react-bootstrap";

const ModalContent1 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-6 col-md-6 col-lg-5">
        <div
          style={{
            backgroundImage: `url(${popupbg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            minHeight: "450px",
          }}
        >
          <img src={webappslider1} className="img-fluid" />
        </div>
      </div>
      <div className="col-xs col-sm-6 col-md-6 col-lg-7">
        <div className="px-4">
          <figure
            className="svgImage"
            style={{
              padding: "1rem 1rem 1rem 1.2rem",
              borderRadius: "50%",
              width: 84,
            }}
          >
            <svg
              stroke="white"
              strokeWidth="0.2"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              width="45.387"
              height="51.864"
              viewBox="0 0 45.387 51.864"
            >
              <g id="circular-arrows" transform="translate(-31.971 0)">
                <g
                  id="Group_130"
                  data-name="Group 130"
                  transform="translate(31.971 0)"
                >
                  <path
                    id="Path_187"
                    data-name="Path 187"
                    d="M155.543,169.057l.245-.245a9.231,9.231,0,0,0,1.349.56v.345a1.557,1.557,0,0,0,1.555,1.555h2.653a1.557,1.557,0,0,0,1.555-1.555v-.346a9.289,9.289,0,0,0,1.349-.56l.245.245a1.559,1.559,0,0,0,2.2,0l1.878-1.878a1.56,1.56,0,0,0,0-2.2l-.245-.245a9.234,9.234,0,0,0,.56-1.349h.345a1.555,1.555,0,0,0,1.552-1.555v-2.653a1.555,1.555,0,0,0-1.552-1.555h-.346a9.3,9.3,0,0,0-.56-1.349l.245-.246a1.56,1.56,0,0,0,0-2.2l-1.877-1.874a1.544,1.544,0,0,0-1.1-.455h0a1.534,1.534,0,0,0-1.093.454l-.245.244a9.294,9.294,0,0,0-1.35-.561V151.3a1.555,1.555,0,0,0-1.555-1.552h-2.653a1.555,1.555,0,0,0-1.555,1.552v.345a9.23,9.23,0,0,0-1.351.56l-.241-.24a1.553,1.553,0,0,0-2.2,0l-1.881,1.878a1.559,1.559,0,0,0,0,2.194l.245.245a9.3,9.3,0,0,0-.56,1.349h-.346a1.555,1.555,0,0,0-1.552,1.555v2.653a1.555,1.555,0,0,0,1.552,1.555h.345a9.24,9.24,0,0,0,.56,1.35l-.248.248a1.559,1.559,0,0,0,0,2.194l1.878,1.878A1.559,1.559,0,0,0,155.543,169.057Zm-3-3,.649-.649a.76.76,0,0,0,.115-.926,7.718,7.718,0,0,1-.847-2.042.76.76,0,0,0-.736-.572h-.916a.035.035,0,0,1-.033-.036v-2.653a.037.037,0,0,1,.033-.036h.916a.759.759,0,0,0,.736-.572,7.773,7.773,0,0,1,.848-2.043.76.76,0,0,0-.116-.925l-.649-.649a.04.04,0,0,1,0-.048l1.881-1.878a.032.032,0,0,1,.047,0l.649.646a.76.76,0,0,0,.925.114,7.713,7.713,0,0,1,2.042-.847.76.76,0,0,0,.572-.736V151.3a.037.037,0,0,1,.036-.033h2.653a.037.037,0,0,1,.036.033v.916a.76.76,0,0,0,.572.736,7.771,7.771,0,0,1,2.043.848.76.76,0,0,0,.924-.115l.653-.65a.025.025,0,0,1,.02-.008h0a.034.034,0,0,1,.026.01l1.875,1.872a.04.04,0,0,1,0,.051l-.649.649a.76.76,0,0,0-.116.925,7.771,7.771,0,0,1,.848,2.043.76.76,0,0,0,.736.572h.916a.037.037,0,0,1,.033.036v2.653a.035.035,0,0,1-.033.036h-.916a.759.759,0,0,0-.736.572,7.717,7.717,0,0,1-.847,2.042.76.76,0,0,0,.115.926l.646.646a.04.04,0,0,1,0,.051l-1.875,1.875a.04.04,0,0,1-.051,0l-.649-.649a.76.76,0,0,0-.925-.116,7.773,7.773,0,0,1-2.043.848.76.76,0,0,0-.572.736v.916a.04.04,0,0,1-.036.036h-2.653a.04.04,0,0,1-.036-.036V168.8a.76.76,0,0,0-.572-.736,7.714,7.714,0,0,1-2.041-.847.76.76,0,0,0-.926.115l-.646.646a.04.04,0,0,1-.051,0l-1.878-1.878A.04.04,0,0,1,152.542,166.056Z"
                    transform="translate(-137.375 -134.574)"
                  />
                  <path
                    id="Path_188"
                    data-name="Path 188"
                    d="M212.034,225.186l2.529,2.263a.76.76,0,0,0,.506.193l.053,0a.76.76,0,0,0,.527-.268l4.806-5.688a.76.76,0,0,0-1.161-.981l-4.3,5.091-1.947-1.742a.76.76,0,1,0-1.013,1.132Z"
                    transform="translate(-193.567 -198.105)"
                  />
                  <path
                    id="Path_189"
                    data-name="Path 189"
                    d="M44.375,39.579A17.09,17.09,0,0,1,51.667,9.1v1.857s0,.009,0,.014a1.991,1.991,0,0,0,1.019,1.774,1.89,1.89,0,0,0,1.94-.122l.033-.023L60.81,8.089a1.909,1.909,0,0,0,.979-1.61,1.909,1.909,0,0,0-.98-1.61L54.659.356,54.626.334a1.889,1.889,0,0,0-1.94-.121,1.991,1.991,0,0,0-1.019,1.774s0,.009,0,.014V3.425A22.494,22.494,0,0,0,39.294,9.219a.76.76,0,0,0,1.029,1.118A20.994,20.994,0,0,1,52.5,4.857a.76.76,0,0,0,.683-.756V2.008a.5.5,0,0,1,.209-.452.384.384,0,0,1,.384.04l6.157,4.517q.028.02.057.038c.17.1.276.228.276.328s-.106.226-.276.328c-.02.012-.039.025-.058.039l-6.156,4.519a.383.383,0,0,1-.384.04.5.5,0,0,1-.209-.452V8.222a.76.76,0,0,0-.854-.754A18.626,18.626,0,0,0,36.051,25.931a18.4,18.4,0,0,0,2.025,8.45,18.78,18.78,0,0,0,5.41,6.43c.017.013.035.025.053.036a1.81,1.81,0,0,1,1,1.571,1.108,1.108,0,0,1-.63.944,1.961,1.961,0,0,1-1.926-.459,21.082,21.082,0,0,1-8.492-16.23V25.189a21.007,21.007,0,0,1,4.431-12.243.76.76,0,1,0-1.2-.932,22.518,22.518,0,0,0-4.75,13.137c0,.008,0,.017,0,.025v1.51c0,.009,0,.017,0,.026a22.594,22.594,0,0,0,9.1,17.408,3.949,3.949,0,0,0,2.332.868,2.7,2.7,0,0,0,1.14-.246,2.625,2.625,0,0,0,1.51-2.226,3.259,3.259,0,0,0-1.681-2.937Z"
                    transform="translate(-31.971 0)"
                  />
                  <path
                    id="Path_190"
                    data-name="Path 190"
                    d="M212.976,78.583a22.9,22.9,0,0,0-6.375-7.778,3.316,3.316,0,0,0-3.325-.76,2.7,2.7,0,0,0-1.7,2.144,3.018,3.018,0,0,0,1.313,2.841,17.09,17.09,0,0,1-7.238,30.515v-1.857s0-.009,0-.014a1.99,1.99,0,0,0-1.016-1.77,1.893,1.893,0,0,0-1.941.117l-.035.024-6.15,4.515a1.813,1.813,0,0,0,0,3.22l6.15,4.515.035.024a1.98,1.98,0,0,0,1.082.331,1.828,1.828,0,0,0,.859-.214,1.99,1.99,0,0,0,1.016-1.77s0-.009,0-.014v-1.428a22.531,22.531,0,0,0,12.022-5.476.76.76,0,0,0-1-1.14,21.025,21.025,0,0,1-11.854,5.183.76.76,0,0,0-.683.756v2.1a.5.5,0,0,1-.209.45.385.385,0,0,1-.385-.038l-6.155-4.518q-.028-.021-.058-.039c-.17-.1-.276-.228-.276-.328s.106-.226.276-.328c.02-.012.039-.025.058-.039l6.155-4.518a.386.386,0,0,1,.386-.038.5.5,0,0,1,.209.45v2.731a.76.76,0,0,0,.854.754,18.622,18.622,0,0,0,16.282-18.463,18.405,18.405,0,0,0-2.034-8.467,18.755,18.755,0,0,0-5.432-6.435,1.529,1.529,0,0,1-.72-1.415,1.179,1.179,0,0,1,.742-.938,1.846,1.846,0,0,1,1.816.515l.021.017a21.181,21.181,0,0,1,3.371,30.165.76.76,0,1,0,1.173.965,22.731,22.731,0,0,0,5.157-14.408,22.465,22.465,0,0,0-2.383-10.135Z"
                    transform="translate(-169.972 -62.787)"
                  />
                </g>
              </g>
            </svg>
          </figure>
          <h3>Automated Compliance</h3>
          <p className="modalUlList">
            Automated Guidance and Tracking of Transactions to Ensure Regulatory
            and Legal Compliance.
          </p>
          <ul className="list-style modalUlList">
            <li>Regulatory Compliance (DORA) &amp; On Demand Reports.</li>
            <li>Pre-packed Transaction Documentation.</li>
            <li>Dates and deadlines reminders</li>
            <li>Troubleshoot information needed to comply for contracts.</li>
            <li>Secure Storage</li>
            <li>Audit Wizard</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const ModalContent2 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-6 col-md-6 col-lg-5">
        <div
          style={{
            backgroundImage: `url(${popupbg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            minHeight: "450px",
          }}
        >
          <img src={webappslider4} className="img-fluid" />
        </div>
      </div>
      <div className="col-xs col-sm-6 col-md-6 col-lg-7">
        <div className="px-4">
          <figure
            className="svgImage"
            style={{
              padding: "1.5rem",
              borderRadius: "50%",
              width: 95,
            }}
          >
            <svg
              stroke="white"
              strokeWidth="0.2"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              width="45.645"
              height="39.939"
              viewBox="0 0 45.645 39.939"
            >
              <path
                id="Icon_metro-table"
                data-name="Icon metro-table"
                d="M2.571,3.856V43.8H48.215V3.856H2.571ZM19.687,29.531V20.973H31.1v8.558ZM31.1,32.384v8.558H19.687V32.384Zm0-22.822V18.12H19.687V9.562H31.1Zm-14.264,0V18.12H5.423V9.562H16.835ZM5.423,20.973H16.835v8.558H5.423V20.973Zm28.528,0H45.362v8.558H33.951V20.973Zm0-2.853V9.562H45.362V18.12ZM5.423,32.384H16.835v8.558H5.423V32.384Zm28.528,8.558V32.384H45.362v8.558Z"
                transform="translate(-2.571 -3.856)"
                fill="#fff"
              />{" "}
            </svg>
          </figure>
          <h3>Offer Comparison Table</h3>
          <p className="modalUlList">
            Provide a dynamic and automated comparison table (spreadsheet)of all
            offers submitted for a property so you can share with yourclient and
            choose the best offer based upon several categories such as:
          </p>
          <ul className="list-style modalUlList">
            <li>Price</li>
            <li>Closing Date</li>
            <li>Financing Type</li>
          </ul>
          <p>
            Fields and priorities are customizable. Huge timesaver and accurate
            presentation for clients.
          </p>
        </div>
      </div>
    </div>
  );
};

const ModalContent3 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-6 col-md-6 col-lg-5">
        <div
          style={{
            backgroundImage: `url(${popupbg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            minHeight: "450px",
          }}
        >
          <img src={webappslider1} className="img-fluid" />
        </div>
      </div>
      <div className="col-xs col-sm-6 col-md-6 col-lg-7">
        <div className="px-4">
          <figure
            className="svgImage"
            style={{
              padding: "1.5rem",
              borderRadius: "50%",
              width: 90,
            }}
          >
            <img src={calendaricon} width="43px" alt="" />
          </figure>
          <h3>Consolidated Calendar</h3>
          <p className="modalUlList">
            See all tasks and reminders for your day to accomplish your business
            objectives.
          </p>
          <ul className="list-style modalUlList">
            <li>
              Tasks to accomplish to stay on top of your Real Estate
              Transactions.
            </li>
            <li>
              Reminders for significant dates for Clients (Birthdays,
              Anniversary of Property Purchase, etc.)
            </li>
            <li>Appointments you need to attend.</li>
            <li>Integrates with Google, Apple, and Outlook Calendar.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const ModalContent4 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-6 col-md-6 col-lg-5">
        <div
          style={{
            backgroundImage: `url(${popupbg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            minHeight: "477px",
            // position:"absolute",
            // top:0,
            // left:0
          }}
        >
          <img
            src={CRMimage}
            className="img-fluid"
            style={{ maxWidth: "50%", margin: "auto" }}
          />
        </div>
      </div>
      <div className="col-xs col-sm-6 col-md-6 col-lg-7">
        <div className="px-4">
          <figure
            className="svgImage"
            style={{
              padding: "1.5rem",
              borderRadius: "50%",
              width: 98,
              marginTop: "15px",
            }}
          >
            <svg
              stroke="white"
              strokeWidth="0.2"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              width={53}
              height="49.872"
              viewBox="0 0 53 49.872"
            >
              <g
                id="Component_58_1"
                data-name="Component 58 – 1"
                transform="translate(0 1)"
              >
                <text
                  id="ICM"
                  transform="translate(0 33.945)"
                  fill="#fff"
                  fontSize={29}
                  fontFamily="Roboto-Regular, Roboto"
                >
                  <tspan x={0} y={0}>
                    ICM
                  </tspan>
                </text>
                <path
                  id="Path_552"
                  data-name="Path 552"
                  d="M549.506,3136.926s4.757-9.515,19.145-9.863,19.029,9.863,19.029,9.863"
                  transform="translate(-543 -3127.055)"
                  fill="none"
                  stroke="#fff"
                  strokeWidth={2}
                />
                <path
                  id="Path_553"
                  data-name="Path 553"
                  d="M549.506,3127.055s4.757,9.515,19.145,9.863,19.029-9.863,19.029-9.863"
                  transform="translate(-543 -3089.055)"
                  fill="none"
                  stroke="#fff"
                  strokeWidth={2}
                />
                <rect
                  id="Rectangle_700"
                  data-name="Rectangle 700"
                  width={2}
                  height={7}
                  transform="translate(8.545 34.929) rotate(50)"
                  fill="#fff"
                />
              </g>
            </svg>
          </figure>
          <h3>Integrated Customer Management </h3>
          <p className="modalUlList">
            Import Customer contact information from your phone and other CRM
            software. Add pictures about your client to remind you about them
            (favorite wine, picture of dog, house purchased, etc.).
            Automatically import customer information into your real estate
            transaction documents.{" "}
          </p>
          <ul className="list-style modalUlList">
            <li>Immediately add client to database</li>
            <li>
              Track client's transactions and notify them when action is needed
            </li>
            <li>
              Send good wishes, congratulations, and other helpful, home
              reminders
            </li>
            {/* <li>Create your own email signature</li> */}
          </ul>
        </div>
      </div>
    </div>
  );
};
const ModalContent5 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-6 col-md-6 col-lg-5">
        <div
          style={{
            backgroundImage: `url(${popupbg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            minHeight: "450px",
          }}
        >
          <img src={webappslider1} className="img-fluid" />
        </div>
      </div>
      <div className="col-xs col-sm-6 col-md-6 col-lg-7">
        <div className="px-4">
          <figure
            className="svgImage"
            style={{
              padding: "1.5rem",
              borderRadius: "50%",
              width: 100,
            }}
          >
            <svg
              stroke="white"
              strokeWidth="0.2"
              fill="white"
              id="secure-shield"
              xmlns="http://www.w3.org/2000/svg"
              width="47.648"
              height="55.872"
              viewBox="0 0 47.648 55.872"
            >
              <g id="Group_30" data-name="Group 30" transform="translate(0 0)">
                <g id="Group_29" data-name="Group 29">
                  <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M84.464,9.648A92.939,92.939,0,0,1,62.1.163a1.175,1.175,0,0,0-1.195,0A90.394,90.394,0,0,1,38.546,9.648a1.175,1.175,0,0,0-.865,1.134V22.79A34.547,34.547,0,0,0,48.172,48.031c5.152,5.049,11.154,7.841,13.333,7.841s8.181-2.792,13.333-7.841A34.547,34.547,0,0,0,85.329,22.79V10.781A1.175,1.175,0,0,0,84.464,9.648ZM82.978,22.79a32.243,32.243,0,0,1-9.785,23.562c-5.067,4.965-10.484,7.169-11.688,7.169s-6.622-2.2-11.688-7.169A32.244,32.244,0,0,1,40.032,22.79V11.673A92.56,92.56,0,0,0,61.505,2.537a95.49,95.49,0,0,0,21.473,9.136Z"
                    transform="translate(-37.681 0)"
                  />
                  <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M89.08,99.688a1.175,1.175,0,0,0-1.524-.663c-2.1.827-4.255,1.589-6.405,2.263a1.175,1.175,0,0,0-.824,1.121v4.539a1.175,1.175,0,1,0,2.351,0v-3.68c1.929-.624,3.856-1.315,5.74-2.057A1.175,1.175,0,0,0,89.08,99.688Z"
                    transform="translate(-75.673 -88.146)"
                  />
                  <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M171.38,88.563a1.176,1.176,0,0,0,.471-.1l.022-.009a1.175,1.175,0,1,0-.949-2.15l-.019.008a1.175,1.175,0,0,0,.475,2.25Z"
                    transform="translate(-155.741 -76.798)"
                  />
                  <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M312.169,345.72a1.176,1.176,0,0,0-1.627.341,28.608,28.608,0,0,1-3.378,4.219,30.029,30.029,0,0,1-3.371,3,1.175,1.175,0,1,0,1.425,1.869,32.392,32.392,0,0,0,3.636-3.235,30.921,30.921,0,0,0,3.656-4.567A1.175,1.175,0,0,0,312.169,345.72Z"
                    transform="translate(-274.342 -307.823)"
                  />
                  <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M277.218,432.127l-.067.04a1.175,1.175,0,1,0,1.177,2.034l.078-.046a1.175,1.175,0,1,0-1.188-2.028Z"
                    transform="translate(-250.496 -384.828)"
                  />
                  <path
                    id="Path_14"
                    data-name="Path 14"
                    d="M129.343,163.266a3.822,3.822,0,1,0-5.4,5.405l6.94,6.94a3.823,3.823,0,0,0,5.4,0l14.487-14.488a3.822,3.822,0,0,0-5.405-5.4L133.581,167.5Zm17.684-5.885a1.471,1.471,0,1,1,2.081,2.081l-14.487,14.487a1.472,1.472,0,0,1-2.081,0l-6.94-6.939a1.471,1.471,0,0,1,2.081-2.081L132.75,170a1.175,1.175,0,0,0,1.662,0Z"
                    transform="translate(-113.53 -137.728)"
                  />
                </g>
              </g>
            </svg>
          </figure>
          <h3>Industry Best Security</h3>
          <p className="modalUlList">
            Cover all aspects of transaction security for access,authorization,
            real-time data, and minimal data storage.
          </p>
          <ul className="list-style modalUlList">
            <li>
              Data storage maintains transaction security and logs new data
              additions or signatures added.
            </li>
            <li>Transport Layer Security.</li>
            <li>
              Biometric (Finger Print and Face Identity) for sign-inand
              documents signatures.
            </li>
            <li>Geographic Security (Location Based Restriction).</li>
            <li>Role Based Access Control.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const ModalContent6 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-6 col-md-6 col-lg-5">
        <div
          style={{
            backgroundImage: `url(${popupbg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            minHeight: "450px",
          }}
        >
          <img src={webappslider1} className="img-fluid" />
        </div>
      </div>
      <div className="col-xs col-sm-6 col-md-6 col-lg-7">
        <div className="px-4">
          <figure
            className="svgImage"
            style={{
              padding: "1.3rem 1rem 1.3rem 1.6rem",
              borderRadius: "50%",
              width: 90,
            }}
          >
            <svg
              class="w-75 h-75"
              stroke="white"
              strokeWidth="0.2"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 286.66 340.728"
            >
              <g id="flash-on-white" transform="translate(0 0)">
                <g
                  id="Group_110"
                  data-name="Group 110"
                  transform="translate(0 0)"
                >
                  <g id="Group_109" data-name="Group 109">
                    <path
                      id="Path_131"
                      data-name="Path 131"
                      d="M326.585,84.824a5.324,5.324,0,0,0-.292-1.459c-.063-.182-.109-.358-.189-.534a5.675,5.675,0,0,0-1.147-1.664l-80.265-79.5a5.734,5.734,0,0,0-1.68-1.136c-.178-.08-.356-.125-.533-.187a5.758,5.758,0,0,0-1.485-.3c-.1.017-.206-.045-.333-.045H80.132A5.706,5.706,0,0,0,74.4,5.679V22.715H45.733A5.706,5.706,0,0,0,40,28.394V335.049a5.706,5.706,0,0,0,5.733,5.679H286.527a5.706,5.706,0,0,0,5.733-5.679V306.655h28.666a5.706,5.706,0,0,0,5.733-5.679V85.182C326.66,85.057,326.6,84.949,326.585,84.824ZM246.4,19.387,307.087,79.5H246.4Zm34.4,309.983H51.466V34.073H74.4v266.9a5.706,5.706,0,0,0,5.733,5.679H280.794Zm34.4-34.073H85.866V11.358H234.929V85.182a5.706,5.706,0,0,0,5.733,5.679h74.532Z"
                      transform="translate(-40)"
                    />
                  </g>
                </g>
                <g
                  id="bolt_1_"
                  data-name="bolt (1)"
                  transform="translate(105.819 76.875)"
                >
                  <path
                    id="Path_221"
                    data-name="Path 221"
                    d="M178.169,35.415,133.844,123.94h29.55l-7.388,78.11L200.332,97.9h-29.55Z"
                    transform="translate(-129.388 -25.832)"
                  />
                  <path
                    id="Path_222"
                    data-name="Path 222"
                    d="M140.233,186.979l8.514-86.183h-31.37L170.1,0l-8.6,69.639h30.9ZM126.289,94.564H154.02l-6.259,63.37L184.245,75.87h-28.2l6.175-50.007Z"
                    transform="translate(-117.378)"
                  />
                </g>
              </g>
            </svg>
          </figure>
          <h3>Lightning Offer</h3>
          <p className="modalUlList">
            {" "}
            Rapid &amp; Automatic Contract Creation While Viewing Property.
          </p>
          <ul className="list-style modalUlList">
            <li>
              Mobile Device Automatically Checks MLS to determinethe property is
              for sale, imports data to new contract.
            </li>
            <li>Automated contract creation while at property.</li>
            <li>
              Autofill contract with imported MLS data. (Price,earnest money,
              title info, inclusions, exclusions, etc.).
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const ModalContent7 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-6 col-md-6 col-lg-5">
        <div
          style={{
            backgroundImage: `url(${popupbg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            minHeight: "450px",
          }}
        >
          <img src={webappslider1} className="img-fluid" />
        </div>
      </div>
      <div className="col-xs col-sm-6 col-md-6 col-lg-7">
        <div className="px-4">
          <figure
            className="svgImage"
            style={{
              padding: "1.5rem 1.5rem 1.5rem 1.7rem",
              borderRadius: "50%",
              width: 93,
            }}
          >
            <svg
              stroke="white"
              strokeWidth="0.2"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              width="35.666"
              height="47.619"
              viewBox="0 0 35.666 47.619"
            >
              <g id="template" transform="translate(-64.262 0)">
                <g
                  id="Group_131"
                  data-name="Group 131"
                  transform="translate(64.262 0)"
                >
                  <path
                    id="Path_203"
                    data-name="Path 203"
                    d="M98.206,47.619H65.984A1.724,1.724,0,0,1,64.262,45.9v-13a.7.7,0,0,1,1.4,0v13a.324.324,0,0,0,.323.323H98.206a.324.324,0,0,0,.323-.323V1.722a.324.324,0,0,0-.323-.323H65.984a.324.324,0,0,0-.323.323V29.632a.7.7,0,0,1-1.4,0V1.722A1.724,1.724,0,0,1,65.984,0H98.206a1.724,1.724,0,0,1,1.722,1.722V45.9a1.724,1.724,0,0,1-1.722,1.722Z"
                    transform="translate(-64.262 0)"
                  />
                </g>
                <g
                  id="Group_133"
                  data-name="Group 133"
                  transform="translate(69.037 3.443)"
                >
                  <g id="Group_132" data-name="Group 132">
                    <path
                      id="Path_204"
                      data-name="Path 204"
                      d="M116.055,43.7a.7.7,0,0,0,.9-.4l.327-.857h2.248l.323.855a.7.7,0,0,0,1.309-.494l-1.982-5.251-.008-.019a.817.817,0,0,0-.758-.508h0a.817.817,0,0,0-.758.51l-.006.016-2,5.251a.7.7,0,0,0,.4.9Zm2.358-4.226L119,41.037h-1.187Z"
                      transform="translate(-115.604 -37.019)"
                    />
                    <path
                      id="Path_205"
                      data-name="Path 205"
                      d="M183.355,64.028a2.111,2.111,0,0,0,.817-.164.7.7,0,0,0,1.306-.346V60.291a.7.7,0,0,0-1.306-.346,2.123,2.123,0,1,0-.817,4.083Zm0-2.848a.725.725,0,1,1-.725.725A.725.725,0,0,1,183.355,61.18Z"
                      transform="translate(-175.128 -57.493)"
                    />
                    <path
                      id="Path_206"
                      data-name="Path 206"
                      d="M245.656,95.682h12.686a.7.7,0,1,0,0-1.4H245.656a.7.7,0,0,0,0,1.4Z"
                      transform="translate(-232.926 -88.957)"
                    />
                    <path
                      id="Path_207"
                      data-name="Path 207"
                      d="M141.023,129.633H116.306a.7.7,0,1,0,0,1.4h24.716a.7.7,0,1,0,0-1.4Z"
                      transform="translate(-115.607 -121.019)"
                    />
                    <path
                      id="Path_208"
                      data-name="Path 208"
                      d="M140.737,166.26h-4.054a.7.7,0,0,0,0,1.4h3.64v4.286H117v-4.286h16.438a.7.7,0,0,0,0-1.4H116.59a.985.985,0,0,0-.984.984v5.114a.985.985,0,0,0,.984.984h24.147a.985.985,0,0,0,.984-.984v-5.114A.985.985,0,0,0,140.737,166.26Z"
                      transform="translate(-115.606 -154.24)"
                    />
                    <path
                      id="Path_209"
                      data-name="Path 209"
                      d="M123.548,261.963H116.59a.985.985,0,0,0-.984.984v17.843a.985.985,0,0,0,.984.984h6.958a.985.985,0,0,0,.984-.984V262.947a.985.985,0,0,0-.984-.984Zm-.414,18.413H117V263.362h6.129Z"
                      transform="translate(-115.606 -241.042)"
                    />
                    <path
                      id="Path_210"
                      data-name="Path 210"
                      d="M298.654,261.963H290.1a.7.7,0,0,0,0,1.4h8.552a.7.7,0,1,0,0-1.4Z"
                      transform="translate(-273.238 -241.042)"
                    />
                    <path
                      id="Path_211"
                      data-name="Path 211"
                      d="M248.8,294.959H235.13a.7.7,0,1,0,0,1.4H248.8a.7.7,0,1,0,0-1.4Z"
                      transform="translate(-223.379 -270.969)"
                    />
                    <path
                      id="Path_212"
                      data-name="Path 212"
                      d="M248.8,327.955H235.13a.7.7,0,1,0,0,1.4H248.8a.7.7,0,1,0,0-1.4Z"
                      transform="translate(-223.379 -300.896)"
                    />
                    <path
                      id="Path_213"
                      data-name="Path 213"
                      d="M248.8,360.952H235.13a.7.7,0,1,0,0,1.4H248.8a.7.7,0,1,0,0-1.4Z"
                      transform="translate(-223.379 -330.824)"
                    />
                    <path
                      id="Path_214"
                      data-name="Path 214"
                      d="M248.8,393.948H235.13a.7.7,0,0,0,0,1.4H248.8a.7.7,0,1,0,0-1.4Z"
                      transform="translate(-223.379 -360.751)"
                    />
                    <path
                      id="Path_215"
                      data-name="Path 215"
                      d="M248.8,426.945H235.13a.7.7,0,1,0,0,1.4H248.8a.7.7,0,1,0,0-1.4Z"
                      transform="translate(-223.379 -390.679)"
                    />
                    <path
                      id="Path_216"
                      data-name="Path 216"
                      d="M245.03,459.941h-9.9a.7.7,0,1,0,0,1.4h9.9a.7.7,0,1,0,0-1.4Z"
                      transform="translate(-223.379 -420.606)"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </figure>
          <h3>Template Based Autofill</h3>
          <p className="modalUlList">
            Pre-fill and save document input to copy for
            additionaloffers/transactions.
          </p>
          <ul className="list-style modalUlList">
            <li>Pre-fill document specifics as needed for transaction type.</li>
            <li>
              Templates for "Residential", "Commercial", "Condo","Townhouse",
              etc.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const ModalContent8 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-6 col-md-6 col-lg-5">
        <div
          style={{
            backgroundImage: `url(${popupbg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            minHeight: "450px",
          }}
        >
          <img src={compressedview} className="img-fluid" />
        </div>
      </div>
      <div className="col-xs col-sm-6 col-md-6 col-lg-7">
        <div className="px-4">
          <figure
            className="svgImage"
            style={{
              padding: "1.5rem",
              borderRadius: "50%",
              width: 94,
            }}
          >
            <svg
              stroke="white"
              strokeWidth="0.2"
              fill="white"
              id="minimize"
              xmlns="http://www.w3.org/2000/svg"
              width="46.149"
              height="46.149"
              viewBox="0 0 46.149 46.149"
            >
              <g id="Group_38" data-name="Group 38">
                <g id="Group_37" data-name="Group 37">
                  <path
                    id="Path_22"
                    data-name="Path 22"
                    d="M2.884,2.884H34.539V0H0V34.612H2.884Z"
                  />
                  <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M160.455,128v31.727H128.8v2.884h34.539V128Z"
                    transform="translate(-117.191 -116.463)"
                  />
                  <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M105.367,282.1h2.884V272h-10.1v2.884h5.172L95.2,283.012l2.039,2.039,8.128-8.128Z"
                    transform="translate(-86.619 -247.484)"
                  />
                  <rect
                    id="Rectangle_14"
                    data-name="Rectangle 14"
                    width="2.884"
                    height="2.884"
                    transform="translate(6.544 41.648) rotate(-135)"
                  />
                  <rect
                    id="Rectangle_15"
                    data-name="Rectangle 15"
                    width="2.884"
                    height="2.884"
                    transform="translate(2.459 45.724) rotate(-135)"
                  />
                  <path
                    id="Path_25"
                    data-name="Path 25"
                    d="M274.884,98.156H272v10.1h10.1v-2.884h-5.172l8.128-8.128L283.012,95.2l-8.128,8.128Z"
                    transform="translate(-247.484 -86.619)"
                  />
                  <rect
                    id="Rectangle_16"
                    data-name="Rectangle 16"
                    width="2.884"
                    height="2.884"
                    transform="translate(39.608 4.5) rotate(45)"
                  />
                  <rect
                    id="Rectangle_17"
                    data-name="Rectangle 17"
                    width="2.884"
                    height="2.884"
                    transform="translate(43.684 0.424) rotate(45)"
                  />
                </g>
              </g>
            </svg>
          </figure>
          <h3>Compressed Contract View</h3>
          <p className="modalUlList">
            Document outline view for convenient reference.
          </p>
          <ul className="list-style modalUlList">
            <li>Lightning speed to find and change document information.</li>
            <li>
              Rapid document navigation - Tap on Topic Header (in app) and go
              immediately to contract specifics.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const ModalContent9 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-6 col-md-6 col-lg-5">
        <div
          style={{
            backgroundImage: `url(${popupbg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            minHeight: "450px",
          }}
        >
          <img src={webappslider1} className="img-fluid" />
        </div>
      </div>
      <div className="col-xs col-sm-6 col-md-6 col-lg-7">
        <div className="px-4">
          <figure
            className="svgImage"
            style={{
              padding: "1.5rem 1.9rem 1.5rem 1.3rem",
              borderRadius: "50%",
              width: 88,
            }}
          >
            <img src={recordkeeper2} width="43px" alt="" />
          </figure>
          <h3>Record Keeper</h3>
          <p className="modalUlList">
            Storage of all Transaction Documents bundled together for future
            reference.
          </p>
          <ul className="list-style modalUlList">
            <li>
              Ability to search for any document for key words such as customer
              name, address, date range, etc.
            </li>
            <li>
              Documents stored as a bundle in case of audits from Regulatory
              Agencies (DORA, etc.)
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
const ModalContent10 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-6 col-md-6 col-lg-5">
        <div
          style={{
            backgroundImage: `url(${popupbg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            minHeight: "450px",
          }}
        >
          <img src={webappslider1} className="img-fluid" />
        </div>
      </div>
      <div className="col-xs col-sm-6 col-md-6 col-lg-7">
        <div className="px-4">
          <figure
            className="svgImage"
            style={{
              padding: "1.5rem 1.5rem 1.5rem 1.4rem",
              borderRadius: "50%",
              width: 93,
            }}
          >
            <svg
              stroke="white"
              strokeWidth="0.2"
              fill="white"
              id="business-report"
              xmlns="http://www.w3.org/2000/svg"
              width="47.775"
              height="44.603"
              viewBox="0 0 47.775 44.603"
            >
              <path
                id="Path_6"
                data-name="Path 6"
                d="M43.576,17H4.2A4.2,4.2,0,0,0,0,21.2V48.446a4.2,4.2,0,0,0,4.2,4.2H17.757L16.73,58.8h-1.8a1.4,1.4,0,1,0,0,2.8H32.846a1.4,1.4,0,1,0,0-2.8h-1.8l-1.026-6.159H43.576a4.2,4.2,0,0,0,4.2-4.2V21.2A4.2,4.2,0,0,0,43.576,17ZM28.207,58.8H19.568l1.026-6.159h6.586ZM44.976,48.446a1.4,1.4,0,0,1-1.4,1.4H4.2a1.4,1.4,0,0,1-1.4-1.4V21.2a1.4,1.4,0,0,1,1.4-1.4H22.488v1.586a1.4,1.4,0,1,0,2.8,0V19.8H43.576a1.4,1.4,0,0,1,1.4,1.4Z"
                transform="translate(0 -17)"
              />
              <path
                id="Path_7"
                data-name="Path 7"
                d="M79.738,122.894a1.546,1.546,0,0,0-1.546,1.546v5.05h-3.5v-10a1.546,1.546,0,1,0-3.092,0v10h-3.5V114.546a1.546,1.546,0,1,0-3.092,0v16.49a1.546,1.546,0,0,0,1.546,1.546H79.738a1.546,1.546,0,0,0,1.546-1.546v-6.6A1.546,1.546,0,0,0,79.738,122.894Z"
                transform="translate(-60.798 -105.437)"
              />
              <path
                id="Path_8"
                data-name="Path 8"
                d="M281.967,121a8.962,8.962,0,0,0-6.409,15.23,1.013,1.013,0,0,0,.145.145A8.965,8.965,0,1,0,281.967,121Zm5.667,7.421h-4.121V124.3A5.9,5.9,0,0,1,287.633,128.421Zm-7.213-4.121v5.026l-3.553,3.553A5.877,5.877,0,0,1,280.421,124.3Zm-1.366,10.765,3.553-3.553h5.026A5.877,5.877,0,0,1,279.054,135.065Z"
                transform="translate(-247.36 -112.612)"
              />
            </svg>
          </figure>
          <h3>Real Transaction Dashboard</h3>
          <p className="modalUlList">
            Dashboard providing automated visual status of the real estate
            transaction.
          </p>
          <ul className="list-style modalUlList">
            <li>Fully responsive and easy to read dashboard.</li>
            <li>Minimal &amp; Clean.</li>
            <li>Color coded reminders and updates.</li>
            <li>Current transaction status updated continuously.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

function UniqueFeature() {
  const [showUniqueFeature, setShowUniqueFeature] = useState(false);
  const [alert, setAlert] = useState(false);
  const [show, setShow] = useState(false);
  const [text, setText] = useState("");
  const handleClose = () => setShow(false);

  const handleShow = () => {
    if (text === "ResureRow") {
      setShowUniqueFeature(!showUniqueFeature);
    } else {
      setShow(true);
    }
  };

  const setAlertTrue = (e) => {
    setAlert(e);
  };

  const handleOk = () => {
    if (text === "ResureRow") {
      setShowUniqueFeature(!showUniqueFeature);
      handleClose();
    } else {
      handleClose();
      setAlertTrue(true);
      setTimeout(() => {
        setAlertTrue(false);
      }, 1000);
    }
  };

  const [iconNum, setIconNum] = useState();
  const [showIconModal, setShowIconModal] = useState(false);
  const handleCloseIconModal = () => setShowIconModal(false);
  const handleIconModalShow = () => setShowIconModal(true);

  const handleClick = (num) => {
    setIconNum(num);
    handleIconModalShow(true);
  };

  return (
    <div>
      <div
        style={{
          display: alert ? "flex" : "none",
          position: "fixed",
          top: 120,
          left: "36%",
          fontSize: "25px",
        }}
      >
        <Alert class="alert alert-danger" role="alert" variant="Secondary">
          Password does not match !
        </Alert>
      </div>
      <>
        <section className="our-features">
          <div className="container">
            <div className="row">
              <div className="col-xs col-sm-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center mb-4">
                <div className="accordianStyle">
                  <h2 className="heading" data-toggle="collapse">
                    Our Unique Features
                  </h2>
                  <>
                    <img
                      src={downarrow}
                      id="accordianPanel"
                      width="30px"
                      alt="arrow"
                      style={{
                        cursor: "pointer",
                        transform: showUniqueFeature
                          ? "rotate(-180deg)"
                          : "none",
                      }}
                      onClick={handleShow}
                    />
                    <Modal
                      style={{ zIndex: 10000 }}
                      show={show}
                      onHide={handleClose}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          <h4
                            style={{
                              color: "rgb(80, 80, 80)",
                            }}
                          >
                            Please enter Password
                          </h4>
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <textarea
                          onChange={(e) => setText(e.target.value)}
                          style={{
                            width: "100%",
                            height: "50px",
                            borderRadius: "8px",
                            margin: "2rem 0 0rem 0",
                            fontSize: "24px",
                          }}
                          placeholder="Enter password"
                        />
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          style={{
                            padding: "0.37rem 1.3rem 0.37rem 1.3rem",
                          }}
                          variant="primary"
                          onClick={handleOk}
                        >
                          Okay
                        </Button>
                        <Button variant="secondary" onClick={handleClose}>
                          Cancel
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                </div>
                <p>
                  Our dashboard is easy to read, responsive and offers all
                  aspects of the transaction:
                </p>
              </div>
            </div>

            <div
              style={{
                display: showUniqueFeature ? "flex" : "none",
              }}
            >
              <div className="row" id="uniqueFeature">
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(1)}
                  className="col-xs col-sm-6 col-md-6 col-lg-4 mb-4"
                >
                  <figure>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="45.387"
                      height="51.864"
                      viewBox="0 0 45.387 51.864"
                    >
                      <g id="circular-arrows" transform="translate(-31.971 0)">
                        <g
                          id="Group_130"
                          data-name="Group 130"
                          transform="translate(31.971 0)"
                        >
                          <path
                            id="Path_187"
                            data-name="Path 187"
                            d="M155.543,169.057l.245-.245a9.231,9.231,0,0,0,1.349.56v.345a1.557,1.557,0,0,0,1.555,1.555h2.653a1.557,1.557,0,0,0,1.555-1.555v-.346a9.289,9.289,0,0,0,1.349-.56l.245.245a1.559,1.559,0,0,0,2.2,0l1.878-1.878a1.56,1.56,0,0,0,0-2.2l-.245-.245a9.234,9.234,0,0,0,.56-1.349h.345a1.555,1.555,0,0,0,1.552-1.555v-2.653a1.555,1.555,0,0,0-1.552-1.555h-.346a9.3,9.3,0,0,0-.56-1.349l.245-.246a1.56,1.56,0,0,0,0-2.2l-1.877-1.874a1.544,1.544,0,0,0-1.1-.455h0a1.534,1.534,0,0,0-1.093.454l-.245.244a9.294,9.294,0,0,0-1.35-.561V151.3a1.555,1.555,0,0,0-1.555-1.552h-2.653a1.555,1.555,0,0,0-1.555,1.552v.345a9.23,9.23,0,0,0-1.351.56l-.241-.24a1.553,1.553,0,0,0-2.2,0l-1.881,1.878a1.559,1.559,0,0,0,0,2.194l.245.245a9.3,9.3,0,0,0-.56,1.349h-.346a1.555,1.555,0,0,0-1.552,1.555v2.653a1.555,1.555,0,0,0,1.552,1.555h.345a9.24,9.24,0,0,0,.56,1.35l-.248.248a1.559,1.559,0,0,0,0,2.194l1.878,1.878A1.559,1.559,0,0,0,155.543,169.057Zm-3-3,.649-.649a.76.76,0,0,0,.115-.926,7.718,7.718,0,0,1-.847-2.042.76.76,0,0,0-.736-.572h-.916a.035.035,0,0,1-.033-.036v-2.653a.037.037,0,0,1,.033-.036h.916a.759.759,0,0,0,.736-.572,7.773,7.773,0,0,1,.848-2.043.76.76,0,0,0-.116-.925l-.649-.649a.04.04,0,0,1,0-.048l1.881-1.878a.032.032,0,0,1,.047,0l.649.646a.76.76,0,0,0,.925.114,7.713,7.713,0,0,1,2.042-.847.76.76,0,0,0,.572-.736V151.3a.037.037,0,0,1,.036-.033h2.653a.037.037,0,0,1,.036.033v.916a.76.76,0,0,0,.572.736,7.771,7.771,0,0,1,2.043.848.76.76,0,0,0,.924-.115l.653-.65a.025.025,0,0,1,.02-.008h0a.034.034,0,0,1,.026.01l1.875,1.872a.04.04,0,0,1,0,.051l-.649.649a.76.76,0,0,0-.116.925,7.771,7.771,0,0,1,.848,2.043.76.76,0,0,0,.736.572h.916a.037.037,0,0,1,.033.036v2.653a.035.035,0,0,1-.033.036h-.916a.759.759,0,0,0-.736.572,7.717,7.717,0,0,1-.847,2.042.76.76,0,0,0,.115.926l.646.646a.04.04,0,0,1,0,.051l-1.875,1.875a.04.04,0,0,1-.051,0l-.649-.649a.76.76,0,0,0-.925-.116,7.773,7.773,0,0,1-2.043.848.76.76,0,0,0-.572.736v.916a.04.04,0,0,1-.036.036h-2.653a.04.04,0,0,1-.036-.036V168.8a.76.76,0,0,0-.572-.736,7.714,7.714,0,0,1-2.041-.847.76.76,0,0,0-.926.115l-.646.646a.04.04,0,0,1-.051,0l-1.878-1.878A.04.04,0,0,1,152.542,166.056Z"
                            transform="translate(-137.375 -134.574)"
                          />
                          <path
                            id="Path_188"
                            data-name="Path 188"
                            d="M212.034,225.186l2.529,2.263a.76.76,0,0,0,.506.193l.053,0a.76.76,0,0,0,.527-.268l4.806-5.688a.76.76,0,0,0-1.161-.981l-4.3,5.091-1.947-1.742a.76.76,0,1,0-1.013,1.132Z"
                            transform="translate(-193.567 -198.105)"
                          />
                          <path
                            id="Path_189"
                            data-name="Path 189"
                            d="M44.375,39.579A17.09,17.09,0,0,1,51.667,9.1v1.857s0,.009,0,.014a1.991,1.991,0,0,0,1.019,1.774,1.89,1.89,0,0,0,1.94-.122l.033-.023L60.81,8.089a1.909,1.909,0,0,0,.979-1.61,1.909,1.909,0,0,0-.98-1.61L54.659.356,54.626.334a1.889,1.889,0,0,0-1.94-.121,1.991,1.991,0,0,0-1.019,1.774s0,.009,0,.014V3.425A22.494,22.494,0,0,0,39.294,9.219a.76.76,0,0,0,1.029,1.118A20.994,20.994,0,0,1,52.5,4.857a.76.76,0,0,0,.683-.756V2.008a.5.5,0,0,1,.209-.452.384.384,0,0,1,.384.04l6.157,4.517q.028.02.057.038c.17.1.276.228.276.328s-.106.226-.276.328c-.02.012-.039.025-.058.039l-6.156,4.519a.383.383,0,0,1-.384.04.5.5,0,0,1-.209-.452V8.222a.76.76,0,0,0-.854-.754A18.626,18.626,0,0,0,36.051,25.931a18.4,18.4,0,0,0,2.025,8.45,18.78,18.78,0,0,0,5.41,6.43c.017.013.035.025.053.036a1.81,1.81,0,0,1,1,1.571,1.108,1.108,0,0,1-.63.944,1.961,1.961,0,0,1-1.926-.459,21.082,21.082,0,0,1-8.492-16.23V25.189a21.007,21.007,0,0,1,4.431-12.243.76.76,0,1,0-1.2-.932,22.518,22.518,0,0,0-4.75,13.137c0,.008,0,.017,0,.025v1.51c0,.009,0,.017,0,.026a22.594,22.594,0,0,0,9.1,17.408,3.949,3.949,0,0,0,2.332.868,2.7,2.7,0,0,0,1.14-.246,2.625,2.625,0,0,0,1.51-2.226,3.259,3.259,0,0,0-1.681-2.937Z"
                            transform="translate(-31.971 0)"
                          />
                          <path
                            id="Path_190"
                            data-name="Path 190"
                            d="M212.976,78.583a22.9,22.9,0,0,0-6.375-7.778,3.316,3.316,0,0,0-3.325-.76,2.7,2.7,0,0,0-1.7,2.144,3.018,3.018,0,0,0,1.313,2.841,17.09,17.09,0,0,1-7.238,30.515v-1.857s0-.009,0-.014a1.99,1.99,0,0,0-1.016-1.77,1.893,1.893,0,0,0-1.941.117l-.035.024-6.15,4.515a1.813,1.813,0,0,0,0,3.22l6.15,4.515.035.024a1.98,1.98,0,0,0,1.082.331,1.828,1.828,0,0,0,.859-.214,1.99,1.99,0,0,0,1.016-1.77s0-.009,0-.014v-1.428a22.531,22.531,0,0,0,12.022-5.476.76.76,0,0,0-1-1.14,21.025,21.025,0,0,1-11.854,5.183.76.76,0,0,0-.683.756v2.1a.5.5,0,0,1-.209.45.385.385,0,0,1-.385-.038l-6.155-4.518q-.028-.021-.058-.039c-.17-.1-.276-.228-.276-.328s.106-.226.276-.328c.02-.012.039-.025.058-.039l6.155-4.518a.386.386,0,0,1,.386-.038.5.5,0,0,1,.209.45v2.731a.76.76,0,0,0,.854.754,18.622,18.622,0,0,0,16.282-18.463,18.405,18.405,0,0,0-2.034-8.467,18.755,18.755,0,0,0-5.432-6.435,1.529,1.529,0,0,1-.72-1.415,1.179,1.179,0,0,1,.742-.938,1.846,1.846,0,0,1,1.816.515l.021.017a21.181,21.181,0,0,1,3.371,30.165.76.76,0,1,0,1.173.965,22.731,22.731,0,0,0,5.157-14.408,22.465,22.465,0,0,0-2.383-10.135Z"
                            transform="translate(-169.972 -62.787)"
                          />
                        </g>
                      </g>
                    </svg>
                  </figure>
                  <h3>Automated Compliance</h3>
                  <p>
                    Automated Guidance and Tracking of Transactions to Ensure
                    Regulatory and Legal Compliance.<span>Read More</span>
                  </p>
                </div>
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(2)}
                  className="col-xs col-sm-6 col-md-6 col-lg-4 mb-4"
                >
                  <figure>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="35.769"
                      height="37.102"
                      viewBox="0 0 35.769 37.102"
                    >
                      <path
                        id="Icon_metro-table"
                        data-name="Icon metro-table"
                        d="M13.748,15.034H2.571v20.12H38.339V3.856H13.748V15.034Zm2.236,8.942V17.269h8.942v6.707Zm8.942,2.236v6.707H15.984V26.212Zm0-17.884v6.707H15.984V8.327h8.942ZM13.748,15.034ZM4.806,17.269h8.942v6.707H4.806Zm22.355,0H36.1v6.707H27.162Zm0-2.236V8.327H36.1v6.707ZM4.806,26.212h8.942v6.707H4.806V26.212Zm22.355,6.707V26.212H36.1v6.707Z"
                        transform="translate(-2.571 1.948)"
                        fill="#fff"
                      />
                      <path
                        id="Icon_metro-dollar2"
                        data-name="Icon metro-dollar2"
                        d="M18.012,12.433a3.284,3.284,0,0,1-.859,2.275,3.707,3.707,0,0,1-2.231,1.178V17.4a.266.266,0,0,1-.276.276H13.48A.28.28,0,0,1,13.2,17.4V15.886a5.441,5.441,0,0,1-1.1-.268,5.3,5.3,0,0,1-1.515-.8,4.92,4.92,0,0,1-.4-.324q-.108-.1-.151-.155a.262.262,0,0,1-.017-.354l.889-1.165a.269.269,0,0,1,.2-.1.214.214,0,0,1,.207.078l.017.017a4.508,4.508,0,0,0,2.1,1.079,3.015,3.015,0,0,0,.639.069,2.093,2.093,0,0,0,1.23-.371,1.209,1.209,0,0,0,.531-1.053.875.875,0,0,0-.129-.458,1.617,1.617,0,0,0-.289-.363,2.369,2.369,0,0,0-.505-.324q-.345-.177-.57-.276t-.691-.281l-.531-.216q-.194-.078-.531-.229t-.54-.268q-.2-.117-.488-.306a3.04,3.04,0,0,1-.462-.367,5.38,5.38,0,0,1-.376-.423,2.112,2.112,0,0,1-.306-.5,3.462,3.462,0,0,1-.181-.574,3,3,0,0,1-.073-.673A2.952,2.952,0,0,1,11,5.19a3.95,3.95,0,0,1,2.2-1.157V2.48A.28.28,0,0,1,13.48,2.2h1.165a.266.266,0,0,1,.276.276V4a4.8,4.8,0,0,1,.954.2,5.531,5.531,0,0,1,.751.289,4.159,4.159,0,0,1,.548.324q.259.181.337.25t.129.121a.25.25,0,0,1,.043.328l-.7,1.26a.235.235,0,0,1-.2.138.275.275,0,0,1-.233-.06q-.026-.026-.125-.1t-.337-.229a4.455,4.455,0,0,0-.505-.276,3.855,3.855,0,0,0-.643-.224,2.88,2.88,0,0,0-.738-.1,2.243,2.243,0,0,0-1.338.371,1.16,1.16,0,0,0-.445,1.373.972.972,0,0,0,.255.358,3.8,3.8,0,0,0,.341.285,3.04,3.04,0,0,0,.483.268q.324.151.522.233t.6.237q.458.173.7.272t.656.3a5.215,5.215,0,0,1,.652.367,5.511,5.511,0,0,1,.535.432,2.235,2.235,0,0,1,.458.548,3.128,3.128,0,0,1,.272.66,2.848,2.848,0,0,1,.112.811Z"
                        transform="translate(-8.734 -2.203)"
                        fill="#fff"
                      />{" "}
                    </svg>
                  </figure>
                  <h3>Offer Comparison Table</h3>
                  <p>
                    Provide a dynamic and automated comparison table
                    (spreadsheet)of all offers submitted for a property so you
                    can share with yourclient and choose the best offer based
                    upon several categories such as:<span>Read More</span>
                  </p>
                </div>
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(3)}
                  className="col-xs col-sm-6 col-md-6 col-lg-4 mb-4"
                >
                  <figure className="CRM-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={40}
                      height="37.426"
                      viewBox="0 0 40 37.426"
                    >
                      <path
                        id="Calendar-Icon-987yghj"
                        d="M19.513,26.664A9.743,9.743,0,1,1,29.274,36.4h-.028a9.692,9.692,0,0,1-9.734-9.735Zm2.584-.077a7.156,7.156,0,1,0,7.239-7.08h-.067A7.183,7.183,0,0,0,22.1,26.58ZM3.845,35.1A3.837,3.837,0,0,1,.215,32.427,4.173,4.173,0,0,1,0,31.083q.007-11.6,0-23.2A3.954,3.954,0,0,1,3.557,3.912c.251-.033.364.033.353.32-.022.622-.011,1.245,0,1.869A3.1,3.1,0,0,0,5.646,8.99a3.065,3.065,0,0,0,3.4-.226,3.09,3.09,0,0,0,1.36-2.62c0-.637.008-1.272,0-1.909,0-.232.038-.336.306-.334q1.645.022,3.291,0c.263,0,.318.088.313.328-.014.622-.008,1.245,0,1.869a3.109,3.109,0,0,0,1.736,2.889,3.067,3.067,0,0,0,3.386-.222A3.091,3.091,0,0,0,20.8,6.147c0-.637.013-1.274,0-1.909-.009-.276.088-.337.347-.335q1.623.018,3.249,0c.263,0,.32.083.314.326-.014.622-.008,1.246,0,1.869a3.112,3.112,0,0,0,1.736,2.889,3.067,3.067,0,0,0,3.4-.223,3.1,3.1,0,0,0,1.368-2.618c0-.637.013-1.272,0-1.908-.009-.274.08-.364.344-.328A3.955,3.955,0,0,1,35.1,7.887q.007,4.2,0,8.4v.357a13.143,13.143,0,0,0-2.017-.9.675.675,0,0,1-.594-.843c.047-.537,0-1.082.014-1.624,0-.209-.059-.306-.276-.277a1.54,1.54,0,0,1-.2,0Q17.565,13.005,3.1,13c-.394,0-.515.077-.513.5q.024,8.774,0,17.547A1.435,1.435,0,0,0,4.08,32.517c3.044-.018,6.089-.018,9.134-.017h5.57a.722.722,0,0,1,.743.382,12.379,12.379,0,0,0,1.715,2.15c-.011.093-.063.074-.1.074H11.768q-3.963.005-7.926-.009Zm22.023-4.831a.507.507,0,0,1,.025-.7c.62-.763,1.236-1.528,1.872-2.274a1.28,1.28,0,0,0,.335-.718c.093-1.044.163-2.089.255-3.132.063-.72.154-1.444.23-2.157.037-.358.278-.46.59-.479a.62.62,0,0,1,.727.429,5.657,5.657,0,0,1,.131,1.2c.131,1.05.179,2.113.263,3.171.049.561.119,1.12.181,1.681a1.216,1.216,0,0,1-.576,1.128c-.939.675-1.851,1.387-2.769,2.089a.926.926,0,0,1-.548.234C26.332,30.735,26.123,30.535,25.868,30.271ZM15.6,29.9H13.693A.622.622,0,0,1,13,29.2q-.008-1.257,0-2.513a.613.613,0,0,1,.672-.681q1.926-.011,3.851,0a.615.615,0,0,1,.674.681q.011,1.255,0,2.512a.622.622,0,0,1-.692.7H15.6Zm-9.7,0a.625.625,0,0,1-.7-.7c0-.836,0-1.676,0-2.512a.622.622,0,0,1,.709-.688q1.884-.007,3.769,0a.63.63,0,0,1,.72.717q.007,1.236,0,2.473c0,.481-.238.705-.729.709H5.9Zm7.772-5.2A.613.613,0,0,1,13,24.022q-.011-1.257,0-2.513a.622.622,0,0,1,.695-.7H17.5a.622.622,0,0,1,.692.7q.008,1.257,0,2.513a.613.613,0,0,1-.674.68H13.676Zm-7.8,0a.613.613,0,0,1-.674-.68c-.007-.838,0-1.676,0-2.513a.622.622,0,0,1,.693-.7H9.705a.624.624,0,0,1,.695.7q0,1.257,0,2.513a.613.613,0,0,1-.672.681H5.879Zm7.858-5.2c-.508,0-.731-.231-.734-.746V16.329a.63.63,0,0,1,.716-.72h3.77c.483,0,.71.235.712.725v2.473a.622.622,0,0,1-.7.7H13.736Zm-7.829,0a.622.622,0,0,1-.7-.692q-.008-1.257,0-2.513a.622.622,0,0,1,.709-.693h3.77a.632.632,0,0,1,.724.713q.007,1.237,0,2.473a.63.63,0,0,1-.725.712H5.9Zm14.9-3.2c0-.412.213-.689.579-.692,1.519-.013,3.039,0,4.572.033A11.87,11.87,0,0,0,20.8,18.993c0-.984,0-1.837,0-2.688Zm7.015-8.5A2,2,0,0,1,26,5.9q-.025-1.989,0-3.977a1.947,1.947,0,1,1,3.895.025c.009.65,0,1.3,0,2.1a13.807,13.807,0,0,1-.079,2.266,1.97,1.97,0,0,1-1.861,1.49.984.984,0,0,1-.138,0Zm-20.667,0A2,2,0,0,1,5.205,5.874c-.011-.663,0-1.325,0-2.142A14.66,14.66,0,0,1,5.283,1.5,1.939,1.939,0,0,1,7.318.015,1.981,1.981,0,0,1,9.1,1.9c.018,1.339.021,2.68,0,4.018A1.985,1.985,0,0,1,7.153,7.807ZM17.389,7.8a1.981,1.981,0,0,1-1.782-1.884q-.029-2.008,0-4.018a1.946,1.946,0,0,1,3.892.042c.011.657,0,1.325,0,2.146a14.784,14.784,0,0,1-.075,2.224,1.941,1.941,0,0,1-1.883,1.5c-.051,0-.1,0-.152-.008Z"
                        transform="translate(0.5 0.526)"
                        fill="#fff"
                        stroke="rgba(0,0,0,0)"
                        strokeMiterlimit={10}
                        strokeWidth={1}
                      />
                    </svg>
                  </figure>
                  <h3>Consolidated Calendar</h3>
                  <p>
                    See all tasks and reminders for your day to accomplish your
                    business objectives.<span>Read More</span>
                  </p>
                </div>
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(4)}
                  className="col-xs col-sm-6 col-md-6 col-lg-4 mb-4"
                >
                  <figure className="CRM-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={53}
                      height="49.872"
                      viewBox="0 0 53 49.872"
                    >
                      <g
                        id="Component_58_1"
                        data-name="Component 58 – 1"
                        transform="translate(0 1)"
                      >
                        <text
                          id="ICM"
                          transform="translate(0 33.945)"
                          fill="#fff"
                          fontSize={29}
                          fontFamily="Roboto-Regular, Roboto"
                        >
                          <tspan x={0} y={0}>
                            ICM
                          </tspan>
                        </text>
                        <path
                          id="Path_552"
                          data-name="Path 552"
                          d="M549.506,3136.926s4.757-9.515,19.145-9.863,19.029,9.863,19.029,9.863"
                          transform="translate(-543 -3127.055)"
                          fill="none"
                          stroke="#fff"
                          strokeWidth={2}
                        />
                        <path
                          id="Path_553"
                          data-name="Path 553"
                          d="M549.506,3127.055s4.757,9.515,19.145,9.863,19.029-9.863,19.029-9.863"
                          transform="translate(-543 -3089.055)"
                          fill="none"
                          stroke="#fff"
                          strokeWidth={2}
                        />
                        <rect
                          id="Rectangle_700"
                          data-name="Rectangle 700"
                          width={2}
                          height={7}
                          transform="translate(8.545 34.929) rotate(50)"
                          fill="#fff"
                        />
                      </g>
                    </svg>
                  </figure>
                  <h3>Integrated Customer Management </h3>
                  <p>
                    Import Customer contact information from your phone and
                    other CRM software:<span>Read More</span>
                  </p>
                </div>
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(5)}
                  className="col-xs col-sm-6 col-md-6 col-lg-4 mb-4"
                >
                  <figure>
                    <svg
                      id="secure-shield"
                      xmlns="http://www.w3.org/2000/svg"
                      width="47.648"
                      height="55.872"
                      viewBox="0 0 47.648 55.872"
                    >
                      <g
                        id="Group_30"
                        data-name="Group 30"
                        transform="translate(0 0)"
                      >
                        <g id="Group_29" data-name="Group 29">
                          <path
                            id="Path_9"
                            data-name="Path 9"
                            d="M84.464,9.648A92.939,92.939,0,0,1,62.1.163a1.175,1.175,0,0,0-1.195,0A90.394,90.394,0,0,1,38.546,9.648a1.175,1.175,0,0,0-.865,1.134V22.79A34.547,34.547,0,0,0,48.172,48.031c5.152,5.049,11.154,7.841,13.333,7.841s8.181-2.792,13.333-7.841A34.547,34.547,0,0,0,85.329,22.79V10.781A1.175,1.175,0,0,0,84.464,9.648ZM82.978,22.79a32.243,32.243,0,0,1-9.785,23.562c-5.067,4.965-10.484,7.169-11.688,7.169s-6.622-2.2-11.688-7.169A32.244,32.244,0,0,1,40.032,22.79V11.673A92.56,92.56,0,0,0,61.505,2.537a95.49,95.49,0,0,0,21.473,9.136Z"
                            transform="translate(-37.681 0)"
                          />
                          <path
                            id="Path_10"
                            data-name="Path 10"
                            d="M89.08,99.688a1.175,1.175,0,0,0-1.524-.663c-2.1.827-4.255,1.589-6.405,2.263a1.175,1.175,0,0,0-.824,1.121v4.539a1.175,1.175,0,1,0,2.351,0v-3.68c1.929-.624,3.856-1.315,5.74-2.057A1.175,1.175,0,0,0,89.08,99.688Z"
                            transform="translate(-75.673 -88.146)"
                          />
                          <path
                            id="Path_11"
                            data-name="Path 11"
                            d="M171.38,88.563a1.176,1.176,0,0,0,.471-.1l.022-.009a1.175,1.175,0,1,0-.949-2.15l-.019.008a1.175,1.175,0,0,0,.475,2.25Z"
                            transform="translate(-155.741 -76.798)"
                          />
                          <path
                            id="Path_12"
                            data-name="Path 12"
                            d="M312.169,345.72a1.176,1.176,0,0,0-1.627.341,28.608,28.608,0,0,1-3.378,4.219,30.029,30.029,0,0,1-3.371,3,1.175,1.175,0,1,0,1.425,1.869,32.392,32.392,0,0,0,3.636-3.235,30.921,30.921,0,0,0,3.656-4.567A1.175,1.175,0,0,0,312.169,345.72Z"
                            transform="translate(-274.342 -307.823)"
                          />
                          <path
                            id="Path_13"
                            data-name="Path 13"
                            d="M277.218,432.127l-.067.04a1.175,1.175,0,1,0,1.177,2.034l.078-.046a1.175,1.175,0,1,0-1.188-2.028Z"
                            transform="translate(-250.496 -384.828)"
                          />
                          <path
                            id="Path_14"
                            data-name="Path 14"
                            d="M129.343,163.266a3.822,3.822,0,1,0-5.4,5.405l6.94,6.94a3.823,3.823,0,0,0,5.4,0l14.487-14.488a3.822,3.822,0,0,0-5.405-5.4L133.581,167.5Zm17.684-5.885a1.471,1.471,0,1,1,2.081,2.081l-14.487,14.487a1.472,1.472,0,0,1-2.081,0l-6.94-6.939a1.471,1.471,0,0,1,2.081-2.081L132.75,170a1.175,1.175,0,0,0,1.662,0Z"
                            transform="translate(-113.53 -137.728)"
                          />
                        </g>
                      </g>
                    </svg>
                  </figure>
                  <h3>Industry Best Security</h3>
                  <p>
                    Cover all aspects of transaction security for
                    access,authorization, real-time data, and minimal data
                    storage.
                    <span>Read More</span>
                  </p>
                </div>
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(6)}
                  className="col-xs col-sm-6 col-md-6 col-lg-4 mb-4"
                >
                  <figure>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 286.66 340.728"
                    >
                      <g id="flash-on-white" transform="translate(0 0)">
                        <g
                          id="Group_110"
                          data-name="Group 110"
                          transform="translate(0 0)"
                        >
                          <g id="Group_109" data-name="Group 109">
                            <path
                              id="Path_131"
                              data-name="Path 131"
                              d="M326.585,84.824a5.324,5.324,0,0,0-.292-1.459c-.063-.182-.109-.358-.189-.534a5.675,5.675,0,0,0-1.147-1.664l-80.265-79.5a5.734,5.734,0,0,0-1.68-1.136c-.178-.08-.356-.125-.533-.187a5.758,5.758,0,0,0-1.485-.3c-.1.017-.206-.045-.333-.045H80.132A5.706,5.706,0,0,0,74.4,5.679V22.715H45.733A5.706,5.706,0,0,0,40,28.394V335.049a5.706,5.706,0,0,0,5.733,5.679H286.527a5.706,5.706,0,0,0,5.733-5.679V306.655h28.666a5.706,5.706,0,0,0,5.733-5.679V85.182C326.66,85.057,326.6,84.949,326.585,84.824ZM246.4,19.387,307.087,79.5H246.4Zm34.4,309.983H51.466V34.073H74.4v266.9a5.706,5.706,0,0,0,5.733,5.679H280.794Zm34.4-34.073H85.866V11.358H234.929V85.182a5.706,5.706,0,0,0,5.733,5.679h74.532Z"
                              transform="translate(-40)"
                            />
                          </g>
                        </g>
                        <g
                          id="bolt_1_"
                          data-name="bolt (1)"
                          transform="translate(105.819 76.875)"
                        >
                          <path
                            id="Path_221"
                            data-name="Path 221"
                            d="M178.169,35.415,133.844,123.94h29.55l-7.388,78.11L200.332,97.9h-29.55Z"
                            transform="translate(-129.388 -25.832)"
                          />
                          <path
                            id="Path_222"
                            data-name="Path 222"
                            d="M140.233,186.979l8.514-86.183h-31.37L170.1,0l-8.6,69.639h30.9ZM126.289,94.564H154.02l-6.259,63.37L184.245,75.87h-28.2l6.175-50.007Z"
                            transform="translate(-117.378)"
                          />
                        </g>
                      </g>
                    </svg>
                  </figure>
                  <h3>Lightning Offer</h3>
                  <p>
                    Rapid &amp; Automatic Contract Creation While Viewing
                    Property.
                    <span>Read More</span>
                  </p>
                </div>
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(7)}
                  className="col-xs col-sm-6 col-md-6 col-lg-4 mb-4"
                >
                  <figure>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="35.666"
                      height="47.619"
                      viewBox="0 0 35.666 47.619"
                    >
                      <g id="template" transform="translate(-64.262 0)">
                        <g
                          id="Group_131"
                          data-name="Group 131"
                          transform="translate(64.262 0)"
                        >
                          <path
                            id="Path_203"
                            data-name="Path 203"
                            d="M98.206,47.619H65.984A1.724,1.724,0,0,1,64.262,45.9v-13a.7.7,0,0,1,1.4,0v13a.324.324,0,0,0,.323.323H98.206a.324.324,0,0,0,.323-.323V1.722a.324.324,0,0,0-.323-.323H65.984a.324.324,0,0,0-.323.323V29.632a.7.7,0,0,1-1.4,0V1.722A1.724,1.724,0,0,1,65.984,0H98.206a1.724,1.724,0,0,1,1.722,1.722V45.9a1.724,1.724,0,0,1-1.722,1.722Z"
                            transform="translate(-64.262 0)"
                          />
                        </g>
                        <g
                          id="Group_133"
                          data-name="Group 133"
                          transform="translate(69.037 3.443)"
                        >
                          <g id="Group_132" data-name="Group 132">
                            <path
                              id="Path_204"
                              data-name="Path 204"
                              d="M116.055,43.7a.7.7,0,0,0,.9-.4l.327-.857h2.248l.323.855a.7.7,0,0,0,1.309-.494l-1.982-5.251-.008-.019a.817.817,0,0,0-.758-.508h0a.817.817,0,0,0-.758.51l-.006.016-2,5.251a.7.7,0,0,0,.4.9Zm2.358-4.226L119,41.037h-1.187Z"
                              transform="translate(-115.604 -37.019)"
                            />
                            <path
                              id="Path_205"
                              data-name="Path 205"
                              d="M183.355,64.028a2.111,2.111,0,0,0,.817-.164.7.7,0,0,0,1.306-.346V60.291a.7.7,0,0,0-1.306-.346,2.123,2.123,0,1,0-.817,4.083Zm0-2.848a.725.725,0,1,1-.725.725A.725.725,0,0,1,183.355,61.18Z"
                              transform="translate(-175.128 -57.493)"
                            />
                            <path
                              id="Path_206"
                              data-name="Path 206"
                              d="M245.656,95.682h12.686a.7.7,0,1,0,0-1.4H245.656a.7.7,0,0,0,0,1.4Z"
                              transform="translate(-232.926 -88.957)"
                            />
                            <path
                              id="Path_207"
                              data-name="Path 207"
                              d="M141.023,129.633H116.306a.7.7,0,1,0,0,1.4h24.716a.7.7,0,1,0,0-1.4Z"
                              transform="translate(-115.607 -121.019)"
                            />
                            <path
                              id="Path_208"
                              data-name="Path 208"
                              d="M140.737,166.26h-4.054a.7.7,0,0,0,0,1.4h3.64v4.286H117v-4.286h16.438a.7.7,0,0,0,0-1.4H116.59a.985.985,0,0,0-.984.984v5.114a.985.985,0,0,0,.984.984h24.147a.985.985,0,0,0,.984-.984v-5.114A.985.985,0,0,0,140.737,166.26Z"
                              transform="translate(-115.606 -154.24)"
                            />
                            <path
                              id="Path_209"
                              data-name="Path 209"
                              d="M123.548,261.963H116.59a.985.985,0,0,0-.984.984v17.843a.985.985,0,0,0,.984.984h6.958a.985.985,0,0,0,.984-.984V262.947a.985.985,0,0,0-.984-.984Zm-.414,18.413H117V263.362h6.129Z"
                              transform="translate(-115.606 -241.042)"
                            />
                            <path
                              id="Path_210"
                              data-name="Path 210"
                              d="M298.654,261.963H290.1a.7.7,0,0,0,0,1.4h8.552a.7.7,0,1,0,0-1.4Z"
                              transform="translate(-273.238 -241.042)"
                            />
                            <path
                              id="Path_211"
                              data-name="Path 211"
                              d="M248.8,294.959H235.13a.7.7,0,1,0,0,1.4H248.8a.7.7,0,1,0,0-1.4Z"
                              transform="translate(-223.379 -270.969)"
                            />
                            <path
                              id="Path_212"
                              data-name="Path 212"
                              d="M248.8,327.955H235.13a.7.7,0,1,0,0,1.4H248.8a.7.7,0,1,0,0-1.4Z"
                              transform="translate(-223.379 -300.896)"
                            />
                            <path
                              id="Path_213"
                              data-name="Path 213"
                              d="M248.8,360.952H235.13a.7.7,0,1,0,0,1.4H248.8a.7.7,0,1,0,0-1.4Z"
                              transform="translate(-223.379 -330.824)"
                            />
                            <path
                              id="Path_214"
                              data-name="Path 214"
                              d="M248.8,393.948H235.13a.7.7,0,0,0,0,1.4H248.8a.7.7,0,1,0,0-1.4Z"
                              transform="translate(-223.379 -360.751)"
                            />
                            <path
                              id="Path_215"
                              data-name="Path 215"
                              d="M248.8,426.945H235.13a.7.7,0,1,0,0,1.4H248.8a.7.7,0,1,0,0-1.4Z"
                              transform="translate(-223.379 -390.679)"
                            />
                            <path
                              id="Path_216"
                              data-name="Path 216"
                              d="M245.03,459.941h-9.9a.7.7,0,1,0,0,1.4h9.9a.7.7,0,1,0,0-1.4Z"
                              transform="translate(-223.379 -420.606)"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </figure>
                  <h3>Template Based Autofill</h3>
                  <p>
                    Pre-fill and save document input to copy for additional
                    offers/transactions.<span>Read More</span>
                  </p>
                </div>
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(8)}
                  className="col-xs col-sm-6 col-md-6 col-lg-4 mb-4"
                >
                  <figure>
                    <svg
                      id="minimize"
                      xmlns="http://www.w3.org/2000/svg"
                      width="46.149"
                      height="46.149"
                      viewBox="0 0 46.149 46.149"
                    >
                      <g id="Group_38" data-name="Group 38">
                        <g id="Group_37" data-name="Group 37">
                          <path
                            id="Path_22"
                            data-name="Path 22"
                            d="M2.884,2.884H34.539V0H0V34.612H2.884Z"
                          />
                          <path
                            id="Path_23"
                            data-name="Path 23"
                            d="M160.455,128v31.727H128.8v2.884h34.539V128Z"
                            transform="translate(-117.191 -116.463)"
                          />
                          <path
                            id="Path_24"
                            data-name="Path 24"
                            d="M105.367,282.1h2.884V272h-10.1v2.884h5.172L95.2,283.012l2.039,2.039,8.128-8.128Z"
                            transform="translate(-86.619 -247.484)"
                          />
                          <rect
                            id="Rectangle_14"
                            data-name="Rectangle 14"
                            width="2.884"
                            height="2.884"
                            transform="translate(6.544 41.648) rotate(-135)"
                          />
                          <rect
                            id="Rectangle_15"
                            data-name="Rectangle 15"
                            width="2.884"
                            height="2.884"
                            transform="translate(2.459 45.724) rotate(-135)"
                          />
                          <path
                            id="Path_25"
                            data-name="Path 25"
                            d="M274.884,98.156H272v10.1h10.1v-2.884h-5.172l8.128-8.128L283.012,95.2l-8.128,8.128Z"
                            transform="translate(-247.484 -86.619)"
                          />
                          <rect
                            id="Rectangle_16"
                            data-name="Rectangle 16"
                            width="2.884"
                            height="2.884"
                            transform="translate(39.608 4.5) rotate(45)"
                          />
                          <rect
                            id="Rectangle_17"
                            data-name="Rectangle 17"
                            width="2.884"
                            height="2.884"
                            transform="translate(43.684 0.424) rotate(45)"
                          />
                        </g>
                      </g>
                    </svg>
                  </figure>
                  <h3>Compressed Contract View </h3>
                  <p>
                    Document outline view for convenient reference.
                    <span>Read More</span>
                  </p>
                </div>
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(9)}
                  className="col-xs col-sm-6 col-md-6 col-lg-4 mb-4"
                >
                  <figure>
                    <img src={recordkeeper2} width="43px" alt="" />
                  </figure>
                  <h3>Record Keeper</h3>
                  <p>
                    Storage of all Transaction Documents bundled together for
                    future reference. <span>Read More</span>
                  </p>
                </div>
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(10)}
                  className="col-xs col-sm-6 col-md-6 col-lg-4 mb-4"
                >
                  <figure>
                    <svg
                      id="business-report"
                      xmlns="http://www.w3.org/2000/svg"
                      width="47.775"
                      height="44.603"
                      viewBox="0 0 47.775 44.603"
                    >
                      <path
                        id="Path_6"
                        data-name="Path 6"
                        d="M43.576,17H4.2A4.2,4.2,0,0,0,0,21.2V48.446a4.2,4.2,0,0,0,4.2,4.2H17.757L16.73,58.8h-1.8a1.4,1.4,0,1,0,0,2.8H32.846a1.4,1.4,0,1,0,0-2.8h-1.8l-1.026-6.159H43.576a4.2,4.2,0,0,0,4.2-4.2V21.2A4.2,4.2,0,0,0,43.576,17ZM28.207,58.8H19.568l1.026-6.159h6.586ZM44.976,48.446a1.4,1.4,0,0,1-1.4,1.4H4.2a1.4,1.4,0,0,1-1.4-1.4V21.2a1.4,1.4,0,0,1,1.4-1.4H22.488v1.586a1.4,1.4,0,1,0,2.8,0V19.8H43.576a1.4,1.4,0,0,1,1.4,1.4Z"
                        transform="translate(0 -17)"
                      />
                      <path
                        id="Path_7"
                        data-name="Path 7"
                        d="M79.738,122.894a1.546,1.546,0,0,0-1.546,1.546v5.05h-3.5v-10a1.546,1.546,0,1,0-3.092,0v10h-3.5V114.546a1.546,1.546,0,1,0-3.092,0v16.49a1.546,1.546,0,0,0,1.546,1.546H79.738a1.546,1.546,0,0,0,1.546-1.546v-6.6A1.546,1.546,0,0,0,79.738,122.894Z"
                        transform="translate(-60.798 -105.437)"
                      />
                      <path
                        id="Path_8"
                        data-name="Path 8"
                        d="M281.967,121a8.962,8.962,0,0,0-6.409,15.23,1.013,1.013,0,0,0,.145.145A8.965,8.965,0,1,0,281.967,121Zm5.667,7.421h-4.121V124.3A5.9,5.9,0,0,1,287.633,128.421Zm-7.213-4.121v5.026l-3.553,3.553A5.877,5.877,0,0,1,280.421,124.3Zm-1.366,10.765,3.553-3.553h5.026A5.877,5.877,0,0,1,279.054,135.065Z"
                        transform="translate(-247.36 -112.612)"
                      />
                    </svg>
                  </figure>
                  <h3>Real Transaction Dashboard</h3>
                  <p>
                    Dashboard providing automated visual status of the real
                    estate transaction.<span>Read More</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>

      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
        show={showIconModal}
        onHide={handleCloseIconModal}
        style={{
          width: "100%",
          padding: 0,
          zIndex: 10000,
        }}
      >
        <Modal.Body
          style={{
            padding: 0,
          }}
        >
          {iconNum === 1 ? (
            <ModalContent1 />
          ) : iconNum === 2 ? (
            <ModalContent2 />
          ) : iconNum === 3 ? (
            <ModalContent3 />
          ) : iconNum === 4 ? (
            <ModalContent4 />
          ) : iconNum === 5 ? (
            <ModalContent5 />
          ) : iconNum === 6 ? (
            <ModalContent6 />
          ) : iconNum === 7 ? (
            <ModalContent7 />
          ) : iconNum === 8 ? (
            <ModalContent8 />
          ) : iconNum === 9 ? (
            <ModalContent9 />
          ) : iconNum === 10 ? (
            <ModalContent10 />
          ) : (
            "no content available"
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default UniqueFeature;
